export default __webpack_public_path__ + "static/media/cp_geo_be.7806d0cb.svg";